import DataObjectField from '@/utilities/classes/data-object-field';
const buildLandlordFileDataObject = (LandlordRecordID, fileName, base64File, fileType, applicantId, tenantName, tenantAddress, ownerEmail, largefiler, relatedBankRecord) => {
  const dataObject = {
    qdbapi: {
      udata: "EVICTION_DIVERSION_APPLICATION_FILE_UPLOAD",
      field: [
        new DataObjectField(fileType, 6),
        {
          _fid: "7",
          _filename: fileName,
          __text: base64File,
        },
        new DataObjectField(applicantId, 65),
        new DataObjectField(tenantName, 66),
        new DataObjectField(tenantAddress, 67),
        new DataObjectField(ownerEmail, 68),
      ],
    },
  };

  if(largefiler == 1 && (fileType == "Bank Account Document" || fileType == "W9" || fileType == "SSN")){
    dataObject.qdbapi.field.push(new DataObjectField(relatedBankRecord, 51));
  }else{
    dataObject.qdbapi.field.push(new DataObjectField(LandlordRecordID, 13));
  }

  return dataObject;
};
export default buildLandlordFileDataObject;
